module.exports = __webpack_public_path__ + "static/media/hou-logo.f519f525.png";